import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { type FC } from 'react';

type HourglassProps = {
    className?: string;
};

const Hourglass: FC<HourglassProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'hourglass'}
            viewBox="0 0 10 16"
            fill="none"
        >
            <path
                d="M9.406 2.803V.576h.525V0H0v.576h.525v2.227C.525 4.64 3.442 7.123 4.547 8 3.442 8.877.525 11.36.525 13.197v2.227H0V16h9.925v-.576H9.4v-2.227C9.4 11.36 6.483 8.877 5.378 8c1.105-.877 4.028-3.36 4.028-5.197zm-2.604 7.213c.506.5.887.934 1.174 1.312H1.955c.287-.378.668-.82 1.174-1.312.712-.704 1.437-1.3 1.837-1.613a20.25 20.25 0 011.836 1.613zm0-4.032c-.712.704-1.437 1.3-1.836 1.613a22.514 22.514 0 01-1.837-1.613C1.355 4.23 1.087 3.238 1.087 2.804V.575h7.751v2.227c.006.435-.262 1.427-2.036 3.181z"
                fill="black"
            />
        </svg>
    );
};

export default Hourglass;
